import type { FC } from 'react';
import SecurityCheck from '@/primitives/security.check.tsx';
import {
  Sidebar,
  SidebarBody,
  SidebarHeader,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
} from '@/primitives/sidebar.tsx';
import logo from '/logo-short.png';
import { useSecurityContext } from '../hooks/security-provider.tsx';
import { UserTypeEnum } from '../types/user-type.ts';
import AccountSwitcher from './account/account-switcher.tsx';
import KeywordLayoutSearch from './keyword-layout-search.tsx';

const LayoutSideBar: FC = () => {
  const { navItems } = useSecurityContext();
  return (
    <Sidebar>
      <SidebarHeader>
        <SidebarItem className='lg:mb-2.5'>
          <img alt='MeetingMD' src={logo} className='w-16' />
          <SidebarLabel>MeetingMD</SidebarLabel>
        </SidebarItem>
      </SidebarHeader>
      <SidebarBody>
        <SidebarSection>
          <AccountSwitcher />
          <SecurityCheck allowedUserTypes={[UserTypeEnum.Admin, UserTypeEnum.StaffMember]}>
            <KeywordLayoutSearch />
          </SecurityCheck>
          {navItems.map(({ label, url }) => (
            <SidebarItem key={label} href={url}>
              {label}
            </SidebarItem>
          ))}
        </SidebarSection>
      </SidebarBody>
    </Sidebar>
  );
};

export default LayoutSideBar;
